function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 35.4v28.3h21.3l14.2 127.5H248l14.2-127.5h21.3V35.4H0zM222.9 163H60.7l-11-99.2h184.2l-11 99.2zM81.5 205.5c13.7 0 24.8 11.1 24.8 24.8s-11.1 24.8-24.8 24.8-24.8-11.1-24.8-24.8 11.1-24.8 24.8-24.8zm120.5 0c13.7 0 24.8 11.1 24.8 24.8s-11.1 24.8-24.8 24.8-24.8-11.1-24.8-24.8 11.1-24.8 24.8-24.8z"
})));